<nav class="layout-breadcrumb">
    <ol>
        <ng-template ngFor let-item let-last="last" [ngForOf]="breadcrumbs$ | async">
            <li class="cursor-pointer" *ngIf="!item.isRoot" routerLink="{{item.url}}">{{item.label}}</li>
			<li *ngIf="item.isRoot">{{item.label}}</li>
            <li *ngIf="!last" class="layout-breadcrumb-chevron"> / </li>
        </ng-template>
    </ol>
</nav>